import React from 'react';
import map from 'lodash/map';

import { CheckCircleIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

import {
  getIdFrom,
  getUuidFrom
} from 'zoomforth_codesbane_viewer/lib/id_utils.js';

import { get as getUser } from 'zoomforth_zf/appglobals/user.js';

import {
  error as showNotificationError,
  success as showNotificationSuccess
} from 'zoomforth_app_basics/action_creators/notifications.js';

import {
  openPageSharer,
  openLinkCreator,
  openSitePreviewCollaborationModal as dispatchOpenSitePreviewCollaborationModal
} from 'zoomforth_shared_management/action_creators/modals.js';

import {
  viewPageInNewTab,
  viewMobilePageInNewTab
} from 'zoomforth_shared_management/lib/view_page_in_new_tab.js';

import {
  getCurrentSubpage
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  getPageId,
  getPageIsTemplate,
  getPageUrlId,
  getPageCanonicalUrl
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  savePageMetaAttrs
} from './pageMeta.js';

import {
  fetchSiteViewerVersionUpgradeMeta
} from './site_viewer_version.js';

import {
  endEditSection
} from './sections.js';

import {
  showModal
} from './editor_modals.js';

import {
  closeHeaderEditor,
  closePageTitleEditor
} from './header.js';


import {
  closeTranslationsEditor
} from './translations.js';

import {
  closeMenuItemEditor
} from './navigation.js';

import {
  makeSaveId,
  startSave,
  commitSave,
  failSave
} from 'zoomforth_shared_management/action_creators/saving.js';

import {
  closeThemeSelector,
  closeStyleSelector
} from './theme.js';

import NotifyErrorDataMaybeLostModal 
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/notify_error_data_maybe_lost_container.jsx';

import PagePublishFlow
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/page_publish_flow/page_publish_flow_container.jsx';

import TemplateDefaultPublishNotification
  from 'zoomforth_codesbane_editor/exterior_editor/notifications/template_default_publish_notification.jsx';

import PageDefaultPublishNotification
  from 'zoomforth_codesbane_editor/exterior_editor/notifications/page_default_publish_notification_container.jsx';

import ErrorNotifciation from 'zoomforth_codesbane_editor/component_lib/error_notification.jsx';

import { get as getPageHistoryTracker } from 'zoomforth_zf/appglobals/page-history-tracker.js';

import {
  UPDATE_SIDEBAR_OPENED_COMPONENT_CACHE,
  SET_SIDEBAR_EXPANSION_SIZE, END_ALL_EDITING
} from 'zoomforth_codesbane_editor/action_types.js';

export const showDebugBar = ()=>
  ({
    type: 'SHOW_DEBUG_BAR'
  });

export const hideDebugBar = ()=>
  ({
    type: 'HIDE_DEBUG_BAR'
  });

export const openSharerForEditingPage = ()=>
  (dispatch, getState)=> {
    const hasCanonicalUrl = !!getPageCanonicalUrl(getState());

    if (hasCanonicalUrl) {
      dispatch(openPageSharer(getPageId(getState())));
    } else {
      dispatch(openLinkCreator(getPageId(getState())));
    }
  };

export const openSitePreviewCollaborationModal = (siteId)=>
  (dispatch, getState)=> {
    dispatch(dispatchOpenSitePreviewCollaborationModal(siteId || getPageId(getState())));
  };

export const setEditingContent = (contentItemsOrUuids, section = null)=>{
  const contentUuids = map(contentItemsOrUuids, getUuidFrom);
  return {
    type: 'SET_EDITING_CONTENT',
    contentUuids,
    section
  };
};


export const beginEditingContent = (contentItemsOrUuids)=> {
  const contentUuids = map(contentItemsOrUuids, getUuidFrom);
  return {
    type: 'BEGIN_EDITING_CONTENT',
    contentUuids: contentUuids
  };
};


export const endEditingContent = (contentItemsOrUuids)=> {
  const contentUuids = map(contentItemsOrUuids, getUuidFrom);
  return {
    type: 'END_EDITING_CONTENT',
    contentUuids: contentUuids
  };
};


export const endAllEditing = ()=> {
  return {
    type: END_ALL_EDITING
  };
};


export const publish = ()=>
  (dispatch, getState)=> {
    dispatch({ type: 'MARK_AS_PUBLISHED' });
    dispatch(showPublishedNotification(getPageId(getState())));
    dispatch(savePageMetaAttrs(['published_version', 'isDraft']));
    getPageHistoryTracker().trackPublishPage();

    // since sites that have never been published won't prompt for an upgrade
    // we check if an upgrade is available after publishes. we never want to
    // open the modal immediately after publish though because it's intrusive
    // for the user.
    dispatch(fetchSiteViewerVersionUpgradeMeta({
      shouldShowUpgradeModal: false
    }));
  };

export const requestApproval = (approvalRequestMessage)=>
  (dispatch)=> {
    dispatch({
      type: 'MARK_AS_REQUESTED_APPROVAL',
      approvalRequestMessage: approvalRequestMessage
    });
    dispatch(savePageMetaAttrs(['approval_pending', 'approval_request_message']));
    getPageHistoryTracker().trackRequestApproval();
    getPageHistoryTracker().trackAddPageComment();
  };


export const setVideoAssetDisplayImage = (videoId, videoFrameSrc)=>
  (dispatch)=> {
    dispatch(saveVideoThumbnail(videoId, videoFrameSrc));
  };


export const viewPage = ({ mobile, forcePreview, themeUuid, siteViewerVersion }) =>
  (dispatch, getState)=> {
    const urlId = getPageUrlId(getState());
    const subpageId = getIdFrom(getCurrentSubpage(getState()));
    const canonicalUrl = getPageCanonicalUrl(getState());

    if (mobile) {
      viewMobilePageInNewTab({ urlId, canonicalUrl, subpageId, forcePreview, themeUuid });

    } else {
      viewPageInNewTab({ urlId, canonicalUrl, subpageId, forcePreview, themeUuid, siteViewerVersion });

    }

  };


export const reload = ()=>
  ()=> {
    window.location.reload();
  };


export const saveVideoThumbnail = (videoId, thumbnailSrc)=>
  (dispatch)=> {

    const saveId = makeSaveId();
    dispatch(startSave('video_thumbnail', saveId, 'Save video thumbnail'));

    $.ajax({
      url : '/video/edit',
      data: {
        video_id: videoId,
        display_image: thumbnailSrc
      },
      dataType: 'json',
      type: 'post'

    })
      .done(()=> {
        dispatch(commitSave(saveId));
      })

      .fail((xhr, responseText)=> {
        dispatch(failSave(saveId));
        dispatch(notifyErrorMaybeLostData(xhr.status, responseText));
      });

  };


export const closeAllEditingFeatures = ()=>
  (dispatch)=> {
    // @TODO this should be refactored into a batching lib like redux-batched-actions
    dispatch(endEditSection());
    dispatch(setEditingContent([]));
    dispatch(closeHeaderEditor());
    dispatch(closeMenuItemEditor());
    dispatch(closePageTitleEditor());
    dispatch(closeThemeSelector());
    dispatch(closeStyleSelector());
    dispatch(closeTranslationsEditor());
  };


export const startPublishFlow = ()=>
  (dispatch, getState)=> {
    const state = getState();
    const pageId = getPageId(state);
    const isTemplate = getPageIsTemplate(state);

    if (isTemplate) {
      dispatch(publish(pageId));
      return;
    }

    dispatch(showModal(PagePublishFlow, { pageId }));
  };


export const showPublishedNotification = (pageId)=>
  (dispatch, getState)=> {
    dispatch(showNotificationSuccess({
      icon: <CheckCircleIcon />,
      children: (
        getPageIsTemplate(getState()) ?
          <TemplateDefaultPublishNotification />
        :
          <PageDefaultPublishNotification pageId={pageId} />
      )
    }));
  };



export const showErrorNotification = (title, message, additionalMessage=null)=>
  (dispatch)=> {
    dispatch(showNotificationError({
      children: <ErrorNotifciation {...{title, message, additionalMessage}} />
    }));
  };


export const setHasPastedAtLeastOnceInFroala = ()=> {
  return { type: 'SET_HAS_PASTED_AT_LEAST_ONCE_IN_FROALA' };
};


export const hideFroalaPasteNotification = ()=> {
  return { type: 'SET_HAS_HIDDEN_FROALA_PASTE_NOTIFICATION' };
};


export const dismissFroalaPasteNotification = ()=>
  (dispatch)=> {
    getUser().save({
      user_onboarding_data: {
        has_dismissed_froala_paste_notification: true
      }
    }, { patch: true });

    dispatch(hideFroalaPasteNotification());
  };


export const notifyErrorMaybeLostData = (httpStatusCode, serverMessage)=>
  (dispatch)=> {
    // this isn't always garunteed so best to check for it here.
    if (!httpStatusCode || !serverMessage) {
      return;
    }

    dispatch(showModal(
      NotifyErrorDataMaybeLostModal,
      {
        httpStatusCode,
        serverMessage
      }
    ));
  };

export const setSidebarIsExpanded = (isExpanded)=> {
  return { type: 'SET_SIDEBAR_IS_EXPANDED', isExpanded };
};

export const setSidebarExpansionSize = (sidebarExpansionSize) => {
  return { type: SET_SIDEBAR_EXPANSION_SIZE, sidebarExpansionSize };
};

export const updateSidebarOpenedComponentCache = (openedComponentCache) => {
  return { type: UPDATE_SIDEBAR_OPENED_COMPONENT_CACHE, openedComponentCache };
};
